import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Carousel from 'react-bootstrap/Carousel';

const useStyles = makeStyles((theme) => ({
  root: {
    textAlign: 'center',
    marginTop: 20,
  },
  carouselWrapper: {
    width: '100%',
    maxWidth: 900,
    margin: '0 auto',
    borderRadius: 12,
    overflow: 'hidden',
  },
  imageFrame: {
    position: 'relative',
    width: '100%',
    paddingTop: '56.25%',
    backgroundColor: '#f5f5f5',
  },
  image: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    display: 'block',
  },
}));

export default function ImageGridList(props) {
  const classes = useStyles();
  const imageData = props.data || [];

  if (!imageData.length) {
    return <></>;
  }

  return (
    <div className={classes.root}>
      <div className={classes.carouselWrapper}>
        <Carousel
          interval={3500}
          indicators={imageData.length > 1}
          controls={imageData.length > 1}
          pause="hover"
        >
          {imageData.map((imageUrl) => (
            <Carousel.Item key={imageUrl}>
              <div className={classes.imageFrame}>
                <img src={imageUrl} alt="Impact" className={classes.image} />
              </div>
            </Carousel.Item>
          ))}
        </Carousel>
      </div>
    </div>
  );
}